<template>
    <section aria-hidden="false" aria-labelledby="steps-uid-6-h-0" class="body current" id="steps-uid-6-p-0"
             role="tabpanel" style="max-height: 500px; overflow-y: auto;">
        <div class="row p-b-100">
            <div class="col-md-12">
                <form @submit.prevent="validate">
                    <label class="col-sm-12 control-label col-form-label">Add Good/Service</label>
                    <div class="form-group row" v-for="(row, index) in rows">
                        <!-- Good/Service -->
                        <div class="col-sm-3">
                            <multiselect :class="{'is-invalid': submitted && errors.has('goodsservice'+index)}"
                                         :clear-on-select="false"
                                         :close-on-select="true"
                                         :hide-selected="true"
                                         :internal-search="false"
                                         :limit="3"
                                         :loading="isLoading"
                                         :max-height="600"
                                         :name="'goodsservice'+index"
                                         :options="services"
                                         :options-limit="300"
                                         :searchable="true"
                                         :show-no-results="false"
                                         @input="setUnit(row)"
                                         @search-change="getGoodsServices"
                                         class="form-control"
                                         data-vv-as="goodsservice"
                                         id="goodsservice"
                                         label="goodsservice"
                                         open-direction="bottom"
                                         placeholder="Search Goods/Service"
                                         selectLabel=""
                                         track-by="id"
                                         v-model="row.good"
                                         v-validate="'required'">
                                <template slot="singleLabel" slot-scope="props">
                                    <div class="option__desc">
                                        <div class="option__desc" style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                            {{ props.option.name }} - {{ props.option.variety }}
                                        </div>
                                    </div>
                                </template>
                                <template slot="option" slot-scope="props">
                                    <div class="option__desc">
                                        <div class="option__desc" v-if="props.option">
                                            <h5>{{ props.option.name }}</h5>
                                            {{props.option.variety}}
                                        </div>
                                        <div class="option__desc" v-else>
                                            <h5>Add New</h5>
                                        </div>
                                    </div>
                                </template>
                            </multiselect>
                            <div class="invalid-feedback" v-if="submitted && errors.has('goodsservice'+index)">
                                {{ errors.first('goodsservice'+index) }}
                            </div>
                        </div>
                        <!-- Quantity -->
                        <div class="col-sm-2 p-l-0 p-r-0">
                            <div class="input-group">
                                <input :class="{'is-invalid': submitted && errors.has('quantity'+index)}"
                                       :id="'quantity'+index"
                                       :name="'quantity'+index"
                                       class="form-control"
                                       data-vv-as="quantity"
                                       placeholder="Quantity"
                                       style="height: 42px; width: calc(100% - 70px)"
                                       type="number"
                                       v-model="row.quantity"
                                       v-validate="'required'">
                                <input :class="{'is-invalid': submitted && errors.has('quantity'+index)}"
                                       :value="row.unit.symbol" class="form-control"
                                       disabled>
                            </div>
                            <div class="invalid-feedback" style="display: block"
                                 v-if="submitted && errors.has('quantity'+index)">{{ errors.first('quantity'+index) }}
                            </div>
                        </div>
                        <!-- Rate -->
                        <div class="col-sm-2 p-r-0">
                            <div class="input-group">
                                <input :class="{'is-invalid': submitted && errors.has('rate'+index)}"
                                       :value="currency" class="form-control"
                                       disabled>
                                <input :class="{'is-invalid': submitted && errors.has('rate'+index)}" :id="'rate'+index"
                                       :name="'rate'+index"
                                       class="form-control"
                                       data-vv-as="rate"
                                       min=".01"
                                       placeholder="Rate"
                                       step="any"
                                       style="height: 42px; width: calc(100% - 50px)"
                                       type="number"
                                       v-model="row.rate"
                                       v-validate="'required'">
                            </div>
                            <div class="invalid-feedback" style="display: block"
                                 v-if="submitted && errors.has('rate'+index)">{{ errors.first('rate'+index) }}
                            </div>
                        </div>

                        <div class="col-sm-3 p-r-0">
                            <div class="input-group">
                                <input :id="'provenance'+index"
                                       :name="'provenance'+index"
                                       class="form-control"
                                       data-vv-as="provenance"
                                       placeholder="Provenance"
                                       style="height: 42px; width: calc(100% - 70px)"
                                       type="text"
                                       v-model="row.provenance">
                            </div>
                        </div>

                        <div class="col-sm-2">
                            <div class="form-group button-group">
                                <button @click="addRow()" class="btn btn-outline-success" style="height: 40px;"
                                        type="button" v-if="index === rows.length - 1">
                                    <i class="fa fa-cart-plus"/>
                                </button>
                                <button @click="removeRow(index)" class="btn btn-outline-danger" style="height: 40px;"
                                        type="button" v-if="rows.length > 1"><i
                                        class="fa fa-trash-alt"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import UnitSelect from "../../../common/UnitSelect";
    import {mapGetters} from "vuex";

    export default {
        name: "Contract",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Multiselect, UnitSelect},
        data() {
            return {
                submitted: false,
                contract: this.$parent.contract,
                expressid: null,
                isLoading: false,
                services: [],
                unit_symbol: '',
                currency: null,
                rows: [
                    {
                        good: null,
                        quantity: null,
                        rate: null,
                        provenance: null,
                        unit: {}
                    }
                ],
                commodity_props: [
                    {
                        key: null,
                        value: null
                    }
                ],
                provenance: null
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.init();
            });
        },
        methods: {
            async init() {
                this.currency = this.currentOrg.currency_symbol;
                this.contract.currency_id = this.currentOrg.currency_id;
                if (this.contract.items.length > 0) {
                    this.rows = this.contract.items;
                }
                // if (this.contract.unit) {
                //     this.$refs.reference.unit = {
                //         "id": this.contract.unit.id,
                //         "name": this.contract.unit.name,
                //         "symbol": this.contract.unit.symbol,
                //     };
                // } else {
                //     this.$refs.reference.unit = {
                //         "id": null,
                //         "name": null,
                //         "symbol": null,
                //     };
                // }
                // if (this.contract.goodsSevicesProps.length > 0) {
                //     this.commodity_props = this.contract.goodsSevicesProps
                // }
                this.expressid = this.currentOrg.express_id;
            },
            async validate() {
                // this.contract.goodsSevicesProps = this.commodity_props;
                this.contract.items = this.rows;
                this.submitted = true;
                let valid = await this.$validator.validate();
                return valid;
            },
            async getGoodsServices(searchText) {
                this.isLoading = true;
                let reply;
                if (this.contract.type === 'PURCHASE') {
                    reply = await this.$http.get("/express/" + this.expressid + "/purchases/goodsservices/search", {
                        params: {
                            search: searchText,
                            excludeOld: true
                        }
                    });
                    this.services = reply.data;
                } else if (this.contract.type === 'SALE') {
                    reply = await this.$http.get("/express/" + this.expressid + "/sales/goodsservices/search", {
                        params: {
                            search: searchText,
                            excludeOld: true
                        }
                    });
                    this.services = reply.data;
                }
                this.isLoading = false;
            },
            onSelect() {
                this.$refs.reference.unit = {
                    "id": this.contract.goodsSerivces.unit.id,
                    "name": this.contract.goodsSerivces.unit.name,
                    "symbol": this.contract.goodsSerivces.unit.symbol,
                };
                this.contract.unit = this.$refs.reference.unit;
                this.unit_symbol = this.contract.goodsSerivces.unit.symbol;
                this.contract.pricingTerm.rate = this.contract.goodsSerivces.rate.amount;
            },
            setUnit(row) {
                if (row) {
                    row.unit = row.good.unit;
                    row.rate = row.good.rate.amount;
                }
            },
            // addRow() {
            //     this.commodity_props.push({
            //         key: null,
            //         value: null
            //     });
            // },
            // removeRow(index) {
            //     this.commodity_props.splice(index, 1);
            // }

            addRow() {
                this.rows.push({
                    good: null,
                    quantity: null,
                    unit: {}
                });
            },
            removeRow(index) {
                this.rows.splice(index, 1);
                this.submitted = false;
            },
        }
    }
</script>

<style scoped>
    .p-b-100 {
        padding-bottom: 100px !important;
    }
</style>
